// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__8iSla","spinner":"Spinner_spinner__vE4SK","rotate":"Spinner_rotate__Yk19S"};